// lazy loading Components
// https://github.com/vuejs/vue-router/blob/dev/examples/lazy-loading/app.js#L8
export default (name, page, index = false) => () => import(`@/modules/${name}/pages/${page}${index ? '/index' : ''}.vue`)
